import type { FlexProps, TableCellProps } from "@chakra-ui/react";
import { pinnedColumnEdge } from "../HorizontalScrollBox";

export const actionsCell: TableCellProps = {
  position: "sticky",
  right: 0,
  bg: "inherit",
  width: "1%",
  whiteSpace: "nowrap",
  sx: pinnedColumnEdge("right"),
};

export const nameCell: TableCellProps = { overflowWrap: "anywhere" };

export const dateCell: TableCellProps = { whiteSpace: "nowrap" };

export const tagList: FlexProps = { flexWrap: "wrap", columnGap: "1", rowGap: "1", maxWidth: "48" };
